import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

// Sentry — initialise before React mounts. Skips silently when DSN is
// absent (e.g. local dev / preview without DSN).
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN_FRONTEND;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "production",
    release: process.env.REACT_APP_RELEASE || "ekselens-com@dev",
    tracesSampleRate: 0.1,
    ignoreErrors: [
      /ResizeObserver loop limit exceeded/i,
      /ResizeObserver loop completed/i,
      /AbortError/i,
      /ChunkLoadError/i,
    ],
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
